import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../../models/Login";
import Table from "./Table";
import Form from "./From";

export interface ITenderServiceDepartment {
  id: number | null;
  department_Name: string;
  description: string;
  status: boolean;
  added_By?: number | null;
  added_On?: Date | null;
}

export const EmptyTenderServiceDepartment: ITenderServiceDepartment = {
  id: null,
  department_Name: "",
  description: "",
  status: true,
  added_By: null,
  added_On: null,
};

export interface IModel {
  open: boolean;
  singleData: ITenderServiceDepartment;
}

const TenderServiceDepartmentMast = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState<IModel>({ open: false, singleData: EmptyTenderServiceDepartment, });
  const [reload, setReload] = useState(false);
  const toast = useRef<any>();

  const hideDialog = () => {
    setModal({ open: false, singleData: EmptyTenderServiceDepartment, });
  };

  return (
    <>
      <Table permission={permissions} setModal={setModal} toast={toast} reload={reload} />
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default TenderServiceDepartmentMast;